import { Drawer, DrawerContent, DrawerHeader, DrawerTitle } from "@/components/ui/drawer";
import { Citation, SearchDocument } from "@/types";
import PdfImage from "@/assets/search/pdf.svg?react";
import MdImage from "@/assets/search/ic-MarkDown.svg?react";
import { XMarkIcon } from "@heroicons/react/16/solid";
import { useTranslation } from "@/locales";

interface MobileDrawerProps {
    isOpen: boolean;
    onClose: () => void;
    files: SearchDocument[];
    citations: Citation[];
    conversationNo: string;
    onPdfClick: (payload: { citation?: Citation; doc?: SearchDocument; conversationNo?: string }) => void;
    onSaveScroll?: () => void;
}

export function MobileDrawer({ isOpen, onClose, files, citations, conversationNo, onPdfClick, onSaveScroll }: MobileDrawerProps) {
    const { t } = useTranslation();

    const fileIds: number[] = [];
    citations.forEach((citation) => {
        if (!fileIds.includes(citation.fileId)) {
            fileIds.push(citation.fileId);
        }
    });

    const referencedFiles = files.filter((item) => fileIds.includes(item.fileId));

    return (
        <Drawer open={isOpen} onOpenChange={(open) => !open && onClose()}>
            <DrawerContent>
                <div className="flex flex-col max-h-[70vh]">
                    <DrawerHeader className="flex flex-row justify-between items-center px-4 py-2">
                        <DrawerTitle className="text-base font-medium">
                            {t("chat.referencedFiles")}
                            {referencedFiles.length ? `(${referencedFiles.length})` : ""}
                        </DrawerTitle>
                        <button onClick={onClose}>
                            <XMarkIcon className="w-5 h-5 text-base font-medium" />
                        </button>
                    </DrawerHeader>
                    <div className="overflow-y-auto grow px-4">
                        {referencedFiles.map((file, index) => (
                            <div className="py-3 border-b last:border-b-0" key={file.fileId}>
                                <div
                                    onClick={() => {
                                        onSaveScroll?.();
                                        const citation: Citation = {
                                            index: index,
                                            page: 1,
                                            fileId: file.fileId,
                                            summary: "",
                                        };
                                        onPdfClick({
                                            citation,
                                            doc: file,
                                            conversationNo: conversationNo,
                                        });
                                    }}>
                                    <div className="flex items-start mb-[4px]">
                                        <div className={"flex text-[14px] flex-shrink-0"}>
                                            {file.type == "PDF" ? (
                                                <PdfImage className="w-[16px] h-[16px] mr-1" />
                                            ) : (
                                                <MdImage className="w-[16px] h-[16px] mr-1" />
                                            )}
                                        </div>
                                        <div className="text-[14px] text-[var(--text-text_primary)] font-medium line-clamp-2 indent-5 ml-[-20px] leading-[16px]">{`${file?.fileName}`}</div>
                                    </div>
                                    <div className="text-[#6A6A6A] text-[12px] line-clamp-2">{file.summary}</div>
                                    <div className="flex justify-between text-[12px] text-[#8A8A8A] mt-2">
                                        <div>收錄於 {file?.knowledgeName || ""}</div>
                                        <div>{file?.inclusionDate || ""}</div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </DrawerContent>
        </Drawer>
    );
}

